export default __webpack_public_path__ + "static/media/thumbnail.d9e5c95d.png";